"use client";

import { useNonUrlContext } from "@/contexts/NonUrlContext";
import { useProductDetailPageContext } from "@/contexts/ProductDetailPageContext";
import { useToast } from "@/hooks/use-toast";
import { useImageExtraContext } from "@/hooks/useImageExtraContext";
import { buyItem } from "@/server/server-actions";
import { NCProductDetailType, ProductDetail } from "@/utils/APIRouteTypes";
import { getCorrectProductDetails } from "@/utils/helper";
import { Properties } from "@/utils/properties";
import { ShoppingBag } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import React from "react";

type Props = {
  productDetails: ProductDetail | NCProductDetailType
};

export default function BuyNow(props: Props) {
  const [isPending, startTransition] = React.useTransition();
  const router = useRouter()
  const [pdCtx, _] = useProductDetailPageContext()
  const nonURIContext = useNonUrlContext()
  const { ImgContext, blendMode } = useImageExtraContext()
  const { toast } = useToast()
  const pathName = usePathname()
  const isCustomizable = pathName.startsWith(Properties.routes.PRODUCT_LIST) || pathName.startsWith(Properties.routes.TEMPLATES)

  const checkoutItem = async () => {
    const res = await buyItem(props.productDetails.id, ImgContext, isCustomizable, pdCtx.qty, nonURIContext.selectedColor?.id, nonURIContext.selectedSize?.id);

    const sp = new URLSearchParams()
    sp.append("id", String(res))

    if (typeof res === "string") router.push("/checkout?" + sp.toString())
    else if (typeof res === "object") {
      toast({
        title: "Error",
        description: "Something went wrong",
        variant: "destructive"
      })
    }
  }

  const handleBuyNow = () => {
    startTransition(checkoutItem);
  };

  return (
    <button
      className='focus:ring-ffaccent-300 group mt-2 flex w-full items-center justify-center rounded-full bg-ffaccent-300 px-5 py-3 text-center text-sm font-medium text-ffaccent-900 hover:bg-ffaccent-400 active:bg-ffaccent-500 transition-all focus:outline-none focus:ring-4 disabled:bg-ffaccent-200'
      onClick={handleBuyNow}
      disabled={isPending}
      id="buy-now-button"
    >
      <ShoppingBag className="size-6 me-2 fill-transparent group-hover:fill-ffaccent-900 group-hover:text-ffaccent-200 transition-all duration-200" />
      Buy Now
      {isPending && <span className="loading loading-spinner loading-xs ms-2" />}
    </button>
  );
}
